import { default as _91slug_93U3iS46k2l7Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93PatpoQxu7pMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_93xs1gypZbQZMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93dNKyUrbqaqMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93jlYDffnNe9Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93rprg4WxEPPMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93IMz3DJlLeXMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_933R8YR89kzrMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_93tMQymIgbpFMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_93izJ8LKvxVtMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_93SLeiANDtp6Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93uVRpAKs0vHMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93fGlVgA5ShtMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_93mMa5WCwNxYMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_93bZBx8XiKEpMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93MLaM6MsF2mMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_93qt7ypkCN8WMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_935CagOljMfqMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_933Cdfr2JF9SMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93v9NqfNcTCHMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_93uwCufbmW28Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_937Zw6ypV8rYMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93K5Lqx3BkmVMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexDNv75Hge50Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbackwOEewvALSNMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweek6BBT9qdEgeMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_93YeMJxTNLEQMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexPDg34OasXXMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcallKCd6sDDhpwMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeiefu4pxJ6LmMMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexVjZJ429eTMMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminutetBhA6tE6LOMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93GYqwklSjwwMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexf9axyTA88zMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as catalogueqccBrde6ATMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaint3kaTaO6glzMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuellNl8dTVLRKJMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_93fyAfftEHZBMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as indexGyZAXDFK20Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqc7228tSIZPMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/faq.vue?macro=true";
import { default as _91id_93ApyQyZIk7oMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as index4m2Jko6er8Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_93iTm66vQcieMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as indexd7WmBvNTevMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexYbkSZIyvegMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as grouptraveljP2nmpBIHxMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexfRYvusUsL7Meta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as lastminuteGwW7EGsoDJMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as map95r4CyeK4GMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokningxQZI23b7DEMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletteroQIcWzm70yMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlinekD7N73Lt5qMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/offline.vue?macro=true";
import { default as failedbtlETlDVVZMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as indexUkierr092qMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/review/index.vue?macro=true";
import { default as searchv1dK6mMgPMMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/search.vue?macro=true";
import { default as indexh8AurpmzxaMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45doney9cr9Fbx8QMeta } from "/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/reiseleder/:id()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/reiseplan",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/cruiseskip",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/tilfredshet-status/:triptypeid()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/dinreise",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/forelesninger",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/anslutning",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/konkurranse",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/bookflight",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/bestill/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93K5Lqx3BkmVMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blogg/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blogg",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/bestill/:tripid()/:step()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/bookflight/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: indexVjZJ429eTMMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/restplasser",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampanje/:name()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampanje",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: catalogueqccBrde6ATMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_93bZBx8XiKEpMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/konkurranse/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamasjon",
    meta: complaint3kaTaO6glzMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93fGlVgA5ShtMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/arrangement/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/arrangement",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/faq.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/gavekort/:id()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/gavekort",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hoteller/:name()",
    meta: _91name_93iTm66vQcieMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hoteller",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_93SLeiANDtp6Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/anslutning/:tab()",
    meta: _91tab_93tMQymIgbpFMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/gruppereiser",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/forelesninger/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/restplasser-tilbud",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/kart",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/dinreise/:tab()",
    meta: _91tab_93IMz3DJlLeXMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhetsbrev",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93rprg4WxEPPMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/evaluere-reisen",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/review/index.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/tilfredshet-status/:triptypeid()/:paxid()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/cruiseskip/:name()",
    meta: _91name_93xs1gypZbQZMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/reiseplan/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/reiseleder/:id()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/reiseleder",
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45doney9cr9Fbx8QMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-04-22-0931/rtg-monorepo/src/layers/web/pages/verification-done.vue")
  }
]